class GoldiqueProductDetailsTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = this.tabs.map((tab) =>
      document.getElementById(tab.getAttribute('aria-controls'))
    );

    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  onClick(event) {
    const tab = event.target.closest('[role="tab"]');
    if (tab && this.contains(tab)) this.activate(tab, true);
  }

  onKeydown(event) {
    const currentIndex = this.tabs.indexOf(event.target);
    if (currentIndex === -1) return;

    let nextIndex;
    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        nextIndex = (currentIndex + 1) % this.tabs.length;
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = this.tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.activate(this.tabs[nextIndex], true);
  }

  activate(activeTab, moveFocus) {
    this.tabs.forEach((tab, index) => {
      const selected = tab === activeTab;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
      this.panels[index].hidden = !selected;
    });

    if (moveFocus) activeTab.focus();
  }
}

if (!customElements.get('goldique-product-details-tabs')) {
  customElements.define('goldique-product-details-tabs', GoldiqueProductDetailsTabs);
}
